import type { Editor } from '@tiptap/react';

// @tiptap/suggestion has no command to close its list and leaves it open on blur, so a list left open would float over
// the picker. Escape is how the mention and emoji lists close.
export const openScheduling = (editor: Editor | null, onOpen: () => void) => {
  if (editor) {
    const escapeKey = new KeyboardEvent('keydown', { key: 'Escape' });
    editor.view.someProp('handleKeyDown', (handleKeyDown) => handleKeyDown(editor.view, escapeKey));
  }
  onOpen();
};
